import type { NDateLocale } from './enUS'
import { ro } from 'date-fns/locale'

const dateRoRO: NDateLocale = {
  name: 'ro-RO',
  locale: ro
}

export default dateRoRO
